import { concat } from 'ramda'

export function createQueryString(query, paginate, queryTransform) {
  const { sort, order, ...allQuery } = query || {}
  const queryEntries = Object.entries({
    ...allQuery
  })
    .map(([key, value]) => {
      if (queryTransform[key]) {
        return queryTransform[key](value)
      }
      return [`[${key}]`, `${value}`]
    })
    .reduce((pairs, pair) => {
      if (Array.isArray(pair[0])) {
        return [...pairs, ...pair.map(([k, v]) => [`filter[where]${k}`, v])]
      }
      pairs.push([`filter[where]${pair[0]}`, pair[1]])
      return pairs
    }, [])
  const paginateEntries = Object.entries({
    ...paginate,
    ...(sort && !order && { sort }),
    ...(order && { order })
  })
    .map(([key, value]) => {
      if (queryTransform[key]) {
        return queryTransform[key](value)
      }
      return [`[${key}]`, `${value}`]
    })
    .reduce((pairs, pair) => {
      if (Array.isArray(pair[0])) {
        return [...pairs, ...pair.map(([k, v]) => [`filter[${k}]`, v])]
      }
      pairs.push([`filter[${pair[0]}]`, pair[1]])
      return pairs
    }, [])
  const newQuery = concat(queryEntries, paginateEntries)
  const urlSearchParams = new URLSearchParams(newQuery)
  return urlSearchParams.toString().length > 0 ? `?${urlSearchParams}` : ''
}
